/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DatasetAudioRecording
 */
export interface DatasetAudioRecording {
  /**
   *
   * @type {number}
   * @memberof DatasetAudioRecording
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetAudioRecording
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof DatasetAudioRecording
   */
  file: string;
}

/**
 * Check if a given object implements the DatasetAudioRecording interface.
 */
export function instanceOfDatasetAudioRecording(value: object): value is DatasetAudioRecording {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fileName' in value) || value['fileName'] === undefined) return false;
  if (!('file' in value) || value['file'] === undefined) return false;
  return true;
}

export function DatasetAudioRecordingFromJSON(json: any): DatasetAudioRecording {
  return DatasetAudioRecordingFromJSONTyped(json, false);
}

export function DatasetAudioRecordingFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetAudioRecording {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fileName: json['file_name'],
    file: json['file'],
  };
}

export function DatasetAudioRecordingToJSON(value?: Omit<DatasetAudioRecording, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    file_name: value['fileName'],
    file: value['file'],
  };
}
